import React, { useState, useEffect } from 'react';
import PhotoSelectionStep from './photo-selection-step';
import ProcessingStep from './processing-step';
import CandidateSelectionStep from './candidate-selection-step';
import { useGetCurrentPersonaSession, useUpdatePersonaSession } from '../../hooks/api-hooks';
import { Stepper } from './stepper';

export enum WizardStep {
  PHOTO_SELECTION,
  PROCESSING,
  CANDIDATE_SELECTION,
  CONFIRMATION
}

const CreateNeofaceWizard: React.FC = () => {
  const [step, setStep] = useState<WizardStep | null>(null);
  const session = useGetCurrentPersonaSession();
  const updateSessionMutation = useUpdatePersonaSession();

  const steps = [
    { name: 'Take Picture' },
    { name: 'Choose Look' }
  ];

  // Example: Once user is done with Step 1 (PhotoSelection):
  const handlePhotoSelectionDone = () => {
    // Move to Step 2
    setStep(WizardStep.PROCESSING);
  };

  // Step 2 -> if the session is done processing:
  const handleProcessingComplete = () => {
    setStep(WizardStep.CANDIDATE_SELECTION);
  };

  // Step 3 -> user picks a candidate
  const handleSelectCandidate = (candidate: any) => {
    setStep(WizardStep.CONFIRMATION);
  };

  // Step 3 or 4 -> if user hits "Change Photo"
  const handleChangePhoto = async () => {
    if(session.data){
      await updateSessionMutation.mutateAsync({
        sessionId: session.data?.id,
        status: 'discarded',
      });
    }

    setStep(WizardStep.PHOTO_SELECTION);
  };

  // First determine the current session state on load
  useEffect(() => {
    if(session.data === null){
      setStep(WizardStep.PHOTO_SELECTION);
    }
    if(session.data?.status === 'processing' || session.data?.status === 'failed'){
      setStep(WizardStep.PROCESSING);
    }
    if(session.data?.status === 'completed'){
      setStep(WizardStep.CANDIDATE_SELECTION);
    }
  }, [session.data]);

  // Render step content:
  let content;
  switch (step) {
    case WizardStep.PHOTO_SELECTION:
      content = (
        <PhotoSelectionStep
          onDone={handlePhotoSelectionDone}
        />
      );
      break;

    case WizardStep.PROCESSING:
    case WizardStep.CANDIDATE_SELECTION:
      content = (
        <CandidateSelectionStep
          onChangePhoto={handleChangePhoto}
        />
      );
      break;
  }

  return (
    <div className='p-4 mx-auto flex flex-col h-full'>
      <Stepper currentStep={step ?? 0} steps={steps} />
      {content}
    </div>
  );
};

export default CreateNeofaceWizard;
